import moment from 'moment-timezone';

import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('calendar');
const GET_CALENDAR = define('GET_CALENDAR', true);
const GET_LX_AVAILABILITY = define('GET_LX_AVAILABILITY', true);

const initialState = {
  isLoading: true,
  isLoadingLxAvailability: true,
  bookings: [],
  lxAvailability: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CALENDAR.PENDING:
      return {
        ...state,
        isLoading: true,
        bookings: []
      };
    case GET_CALENDAR.RESOLVED:
      return {
        ...state,
        isLoading: false,
        bookings: action.data,
      };
    case GET_LX_AVAILABILITY.PENDING:
      return {
        ...state,
        isLoadingLxAvailability: true,
        lxAvailability: [],
      };
    case GET_LX_AVAILABILITY.RESOLVED:
      return {
        ...state,
        isLoadingLxAvailability: false,
        lxAvailability: action.data,
      };
    default: return state;
  }
};

export const actions = {
  loadCalendar: (month = moment().get('month') + 1, year = moment().get('year')) => ({
    type: GET_CALENDAR,
    promise: api.get(`/bookings/calendar?month=${month}&year=${year}`),
    error: 'Unable to load calendar'
  }),
  getLxAvailability: (userIds, month) => ({
    type: GET_LX_AVAILABILITY,
    promise: api.post('/info/check-lx-availability', { user_ids: userIds, month }),
    error: 'Error load LX availability'
  })
};



// WEBPACK FOOTER //
// ./src/ducks/calendar.js